import React, {useEffect, useRef} from 'react';
import ModelUploadPageHeader from '../common/ModelUploadPageHeader';
import {ModelTreeNode} from '../../../../store/modelFile';
import ModelEditMetadataForm from '../../model/common/ModelEdit/ModelEditMetadata/ModelEditMetadataForm';
import ModelUploadFooter from '../common/ModelUploadFooter';
import {ModelDTO} from 'hemwb-api';
import {FormGroup} from 'react-reactive-form';
import {mapValuesToModel} from '../../model/common/ModelEdit/ModelEditMetadata/utils';
import {Values} from '../../model/common/ModelEdit/ModelEditMetadata/constants';
import {trackMetaDataTabEvent} from '../../../../tracking/tracking';
import StepMetadataRedesigned from './StepMetadataRedesigned';
import ModelUploadFooterAntd from '../common/ModelUploadFooterAntd';

type StepMetadataProps = {
  model: ModelDTO;
  files: ModelTreeNode[];
  onChange: (updatedModel: ModelDTO) => void;
  onSubmit: (updatedModel: ModelDTO) => void;
  onRevopsNameChange?: (revopsName: string) => void;
  onStewardReset?: (steward: {id?: string; email?: string; name?: string}) => void;
  showErrors: boolean;
  onBack?: () => void;
  onNext?: () => void;
  useRedesign?: boolean;
  buttons?: (params: {
    backText?: string;
    onNext?: () => void;
    onBack?: () => void;
    disableNext?: boolean;
    nextHtmlType?: 'button' | 'submit' | 'reset';
  }) => React.ReactNode;
};

const renderButtons = (renderParams: any) => {
  return <ModelUploadFooter {...renderParams} />;
};

const renderButtonsAntd = (params?: any) => {
  return <ModelUploadFooterAntd {...params} />;
};

const StepMetadata: React.FC<StepMetadataProps> = ({
  showErrors,
  files,
  model,
  onSubmit,
  onChange,
  onRevopsNameChange,
  onStewardReset,
  onBack,
  onNext,
  useRedesign = false,
  buttons,
}) => {
  const formObjectRef = useRef<FormGroup>();

  useEffect(() => {
    trackMetaDataTabEvent();
    if (formObjectRef.current) {
      const onFormChange = (values: Values) => onChange(mapValuesToModel(values, model, false));
      formObjectRef.current.valueChanges.subscribe(onFormChange);
    }
  }, [formObjectRef]);

  // Use redesigned version only when enabled
  if (useRedesign) {
    return (
      <StepMetadataRedesigned
        model={model}
        files={files}
        onChange={onChange}
        onSubmit={onSubmit}
        onRevopsNameChange={onRevopsNameChange}
        onStewardReset={onStewardReset}
        showErrors={showErrors}
        onBack={onBack}
        onNext={onNext}
        buttons={buttons || renderButtonsAntd}
      />
    );
  }

  // Original version
  return (
    <div>
      <ModelUploadPageHeader
        title="Fill in Metadata"
        subTitle="It helps us find the lineage and version, and generate model entry name for you"
        aside="For naming convention and version control consistency"
      />
      <div className="whiteTheme" style={{maxWidth: '80rem', margin: '0 auto'}}>
        <ModelEditMetadataForm
          formObjectRef={formObjectRef}
          files={files}
          model={model}
          onSubmit={onSubmit}
          validateOnInit={showErrors}
          buttons={renderButtons}
        />
      </div>
    </div>
  );
};

export default StepMetadata;
